import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "tw-min-h-[calc(100vh-60px)] tw-bg-gradient-to-br tw-from-slate-50 tw-via-white tw-to-indigo-50 tw-w-full tw-overflow-x-hidden" }
const _hoisted_2 = { class: "tw-w-full tw-p-[10px]" }
const _hoisted_3 = { class: "tw-mb-4 tw-w-full tw-border-b tw-border-white/40 tw-bg-white/35 tw-backdrop-blur-md tw-shadow-sm tw-shadow-slate-900/5 tw-py-4" }
const _hoisted_4 = { class: "tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3" }
const _hoisted_5 = { class: "tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-4" }
const _hoisted_6 = { class: "tw-text-2xl sm:tw-text-3xl tw-font-semibold tw-tracking-tight tw-text-slate-800 tw-flex tw-items-center" }
const _hoisted_7 = { class: "tw-inline-flex tw-items-center tw-gap-1.5 tw-bg-white/60 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xl tw-font-medium tw-text-slate-700" }
const _hoisted_8 = { class: "tw-text-lg tw-font-bold" }
const _hoisted_9 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-px-2.5 tw-py-1 tw-bg-amber-100 tw-text-amber-900"
}
const _hoisted_10 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-px-2.5 tw-py-1 tw-bg-sky-100 tw-text-sky-900"
}
const _hoisted_11 = { class: "tw-text-lg" }
const _hoisted_12 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-500/15 tw-px-2.5 tw-py-1 tw-font-medium tw-text-amber-800"
}
const _hoisted_13 = {
  key: 2,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-rose-500/15 tw-px-2.5 tw-py-1 tw-font-medium tw-text-rose-800"
}
const _hoisted_14 = {
  key: 3,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-indigo-500/15 tw-px-2.5 tw-py-1 tw-font-medium tw-text-indigo-800"
}
const _hoisted_15 = {
  key: 4,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-rose-500/15 tw-px-2.5 tw-py-1 tw-font-medium tw-text-rose-800"
}
const _hoisted_16 = {
  key: 5,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-500/15 tw-px-2.5 tw-py-1 tw-font-medium tw-text-emerald-800"
}
const _hoisted_17 = {
  key: 6,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-slate-500/15 tw-px-2.5 tw-py-1 tw-font-medium tw-text-slate-800"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  disabled: "",
  title: "Please complete all trips before completing the order"
}
const _hoisted_20 = {
  key: 1,
  class: "tw-text-sm tw-text-slate-600"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "tw-flex tw-flex-wrap tw-gap-2" }
const _hoisted_23 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-sm tw-text-slate-600"
}
const _hoisted_24 = {
  key: 1,
  class: "tw-text-sm tw-font-semibold tw-text-slate-700"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-700 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-white"
}
const _hoisted_27 = {
  key: 0,
  class: "tw-flex tw-items-center tw-justify-center tw-py-16"
}
const _hoisted_28 = {
  key: 1,
  class: "tw-text-left"
}
const _hoisted_29 = { class: "tw-mt-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4" }
const _hoisted_30 = { class: "tw-mt-4 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50 tw-p-3 sm:tw-p-4" }
const _hoisted_31 = { class: "tw-overflow-x-auto" }
const _hoisted_32 = { class: "tw-min-w-full tw-text-left tw-text-sm tw-text-slate-700" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { key: 3 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = {
  key: 4,
  class: "tw-flex tw-items-center tw-gap-2 tw-nowrap"
}
const _hoisted_42 = { key: 5 }
const _hoisted_43 = { key: 6 }
const _hoisted_44 = { key: 7 }
const _hoisted_45 = {
  key: 1,
  class: "tw-text-xs tw-text-slate-400"
}
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 0,
  class: "tw-mt-3 tw-flex tw-justify-end tw-gap-2"
}
const _hoisted_52 = { class: "tw-mt-4 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50" }
const _hoisted_53 = {
  key: 0,
  class: "tw-mt-4"
}
const _hoisted_54 = { class: "uk-flex uk-margin-small-bottom" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = {
  key: 2,
  class: "tw-mt-3 tw-flex tw-justify-end tw-gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_OrderContainerDetails = _resolveComponent("OrderContainerDetails")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_AddNotesModal = _resolveComponent("AddNotesModal")!
  const _component_OrderLogsModal = _resolveComponent("OrderLogsModal")!
  const _component_TerminalAddressCard = _resolveComponent("TerminalAddressCard")!
  const _component_ReceiverAddressCard = _resolveComponent("ReceiverAddressCard")!
  const _component_BillToAddressCard = _resolveComponent("BillToAddressCard")!
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_EditVessel = _resolveComponent("EditVessel")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Button = _resolveComponent("Button")!
  const _component_OrderContainersTable = _resolveComponent("OrderContainersTable")!
  const _component_VesselFinderEmbed = _resolveComponent("VesselFinderEmbed")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              type: "button",
              class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5 hover:tw-bg-white",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToOrders && _ctx.backToOrders(...args))),
              title: "Back to Orders",
              "aria-label": "Back to Orders"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "arrow-left" })
            ])), [
              [_directive_tippy, {content: 'Back to Orders', placement: 'top-end' }]
            ]),
            _createElementVNode("h1", _hoisted_6, [
              _cache[25] || (_cache[25] = _createTextVNode(" Order ", -1)),
              (_ctx.order)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[24] || (_cache[24] = _createTextVNode(" #", -1)),
                    _createVNode(_component_CopyButton, {
                      value: String(_ctx.order.id),
                      mode: "wrap-content",
                      title: "Copy order ID",
                      "aria-label": "Copy order ID to clipboard"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.order.id), 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (_ctx.order)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_7, [
                    (!_ctx.order.isExport && _ctx.order.billOfLading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[26] || (_cache[26] = _createTextVNode(" BL# ", -1)),
                          _createVNode(_component_CopyButton, {
                            value: _ctx.order.billOfLading.billOfLadingId,
                            mode: "wrap-content",
                            title: "Copy B/L ID",
                            "aria-label": "Copy B/L ID to clipboard"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.order.billOfLading.billOfLadingId), 1)
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.order.houseBillOfLading && _ctx.order.houseBillOfLading != '')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _cache[27] || (_cache[27] = _createTextVNode(" HBL# ", -1)),
                          _createVNode(_component_CopyButton, {
                            value: _ctx.order.houseBillOfLading,
                            mode: "wrap-content",
                            title: "Copy house B/L",
                            "aria-label": "Copy house B/L to clipboard"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.order.houseBillOfLading), 1)
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ], 64))
                      : (_ctx.order.bookingNumber)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _cache[28] || (_cache[28] = _createTextVNode(" BKG # ", -1)),
                            _createVNode(_component_CopyButton, {
                              value: String(_ctx.order.bookingNumber),
                              mode: "wrap-content",
                              title: "Copy booking number",
                              "aria-label": "Copy booking number to clipboard"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.order.bookingNumber), 1)
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ], 64))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_8, [
                    (_ctx.order.containers.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.order.isExport)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.order.containers.length) + " Export" + _toDisplayString(_ctx.order.containers.length > 1 ? 's' : ''), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.order.containers.length) + " Import" + _toDisplayString(_ctx.order.containers.length > 1 ? 's' : ''), 1))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_11, [
                    (!_ctx.isEditStatus)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          ((
                      _ctx.order.status != 'Complete' &&
                      _ctx.orderCompletionStatus() == 'Complete'
                    ))
                            ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: "warning",
                                class: "tw-h-4 tw-w-4 tw-text-rose-900"
                              }, null, 512)), [
                                [_directive_tippy, 'All trips for active (non-cancelled) containers are complete. You should complete the order.']
                              ])
                            : _createCommentVNode("", true),
                          (!_ctx.order.status)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Unknown"))
                            : (_ctx.order.status == 'Cancelled')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Cancelled"))
                              : (_ctx.order.status == 'Complete')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Complete"))
                                : (_ctx.order.status == 'Not Available')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Not Available"))
                                  : (_ctx.order.status === 'In Progress')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.order.status), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.order.status), 1)),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "pen-to-square",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isEditStatus = true)),
                            class: "tw-cursor-pointer"
                          })
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _withDirectives(_createElementVNode("select", {
                            class: "tw-h-10 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-3 tw-text-slate-800 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/20",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderStatus) = $event)),
                            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectOrderStatus && _ctx.selectOrderStatus(...args)))
                          }, [
                            _cache[29] || (_cache[29] = _createElementVNode("option", { value: "Not Available" }, "Not Available", -1)),
                            _cache[30] || (_cache[30] = _createElementVNode("option", null, "Available", -1)),
                            _cache[31] || (_cache[31] = _createElementVNode("option", null, "In Progress", -1)),
                            (_ctx.orderCompletionStatus() == 'Complete')
                              ? (_openBlock(), _createElementBlock("option", _hoisted_18, " Complete "))
                              : (_openBlock(), _createElementBlock("option", _hoisted_19, " Complete ")),
                            _cache[32] || (_cache[32] = _createElementVNode("option", null, "Cancelled", -1))
                          ], 544), [
                            [_vModelSelect, _ctx.orderStatus]
                          ]),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "xmark",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isEditStatus = false)),
                            class: "tw-cursor-pointer"
                          })
                        ], 64))
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, "Review details, containers, notes, and logs."))
          ]),
          (_ctx.order)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.order.createdAt)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Created: " + _toDisplayString(_ctx.order.createdAt), 1))
                    : _createCommentVNode("", true),
                  (_ctx.order.linkedMasterOrderNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Linked Order # " + _toDisplayString(_ctx.order.linkedMasterOrderNumber), 1))
                    : _createCommentVNode("", true),
                  (_ctx.order.status == 'Complete')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-shadow-slate-900/10 hover:tw-bg-slate-800",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToBillingPageForThisOrder(_ctx.order.id)))
                      }, " Billing Page "))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5 hover:tw-bg-white",
                    href: _ctx.printCoverURL(_ctx.order.id),
                    target: "_blank"
                  }, [
                    _cache[33] || (_cache[33] = _createTextVNode(" Cover Sheet ", -1)),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "print",
                      class: "tw-h-4 tw-w-4 tw-ml-2"
                    })
                  ], 8, _hoisted_25),
                  (_ctx.order)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: _normalizeClass(_ctx.order?.notes?.length > 0
                  ? 'tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-emerald-300 tw-bg-emerald-50/80 tw-backdrop-blur tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-emerald-700 tw-shadow-sm tw-shadow-emerald-900/5 hover:tw-bg-emerald-100/80'
                  : 'tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5 hover:tw-bg-white'),
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openNotesModal && _ctx.openNotesModal(...args)))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "sticky-note" }),
                        _cache[34] || (_cache[34] = _createElementVNode("span", null, "Notes", -1)),
                        (_ctx.order?.notes?.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.order.notes.length), 1))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.order)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        type: "button",
                        class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5 hover:tw-bg-white",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openLogsModal && _ctx.openLogsModal(...args)))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                        _cache[35] || (_cache[35] = _createElementVNode("span", null, "Logs", -1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.$apollo.queries.order.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createVNode(_component_font_awesome_icon, {
              icon: "circle-notch",
              spin: "",
              class: "tw-h-10 tw-w-10 tw-text-slate-400"
            })
          ]))
        : (_ctx.order)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createVNode(_component_Modal, {
                isOpen: _ctx.isContainerModalOpen,
                "onUpdate:isOpen": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isContainerModalOpen) = $event)),
                modalId: `container-modal-${_ctx.order.id}-${_ctx.currentContainerId}`,
                maxWidth: "7xl"
              }, {
                title: _withCtx(() => [
                  _cache[36] || (_cache[36] = _createTextVNode(" Container ", -1)),
                  (_ctx.currentContainer?.containerId === 'EXPUNDEF')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("(no number)")
                      ], 64))
                    : (_openBlock(), _createBlock(_component_CopyButton, {
                        key: 1,
                        value: _ctx.currentContainer?.containerId || '',
                        mode: "wrap-content",
                        title: "Copy container number",
                        "aria-label": "Copy container number to clipboard"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currentContainer?.containerId || ''), 1)
                        ]),
                        _: 1
                      }, 8, ["value"])),
                  _createTextVNode("-" + _toDisplayString(String(_ctx.containersWithTrips.findIndex(c => c.id === _ctx.currentContainerId) + 1).padStart(2,'0')), 1)
                ]),
                subtitle: _withCtx(() => [
                  _cache[37] || (_cache[37] = _createTextVNode(" Order #", -1)),
                  _createVNode(_component_CopyButton, {
                    value: _ctx.order.id,
                    mode: "wrap-content",
                    title: "Copy order ID",
                    "aria-label": "Copy order ID to clipboard"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.order.id), 1)
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                content: _withCtx(() => [
                  _createVNode(_component_OrderContainerDetails, {
                    chassis: _ctx.chassis,
                    drivers: _ctx.drivers,
                    order: _ctx.order,
                    editable: _ctx.editable,
                    containerId: _ctx.currentContainerId
                  }, null, 8, ["chassis", "drivers", "order", "editable", "containerId"])
                ]),
                _: 1
              }, 8, ["isOpen", "modalId"]),
              _createVNode(_component_AddNotesModal, {
                open: _ctx.isNotesModalOpen,
                title: "Notes",
                subtitle: _ctx.order ? `Order #${_ctx.order.id}` : undefined,
                order: _ctx.order,
                onClose: _ctx.closeNotesModal,
                onAddedNote: _ctx.updateNotes
              }, null, 8, ["open", "subtitle", "order", "onClose", "onAddedNote"]),
              _createVNode(_component_OrderLogsModal, {
                isOpen: _ctx.isLogsModalOpen,
                "onUpdate:isOpen": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isLogsModalOpen) = $event)),
                order: _ctx.order,
                onClose: _ctx.closeLogsModal
              }, null, 8, ["isOpen", "order", "onClose"]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_TerminalAddressCard, {
                  class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-900/5 tw-p-4",
                  isExportOrder: _ctx.isExportOrder,
                  order: _ctx.order,
                  onUpdateOrder: _ctx.updateOrder
                }, null, 8, ["isExportOrder", "order", "onUpdateOrder"]),
                _createVNode(_component_ReceiverAddressCard, {
                  onRefreshOrder: _ctx.emitRefreshOrders,
                  order: _ctx.order,
                  onUpdateOrder: _ctx.updateOrder
                }, null, 8, ["onRefreshOrder", "order", "onUpdateOrder"]),
                _createVNode(_component_BillToAddressCard, {
                  billingContact: _ctx.order.billingContact,
                  orderId: _ctx.order.id,
                  billTo: _ctx.order.billTo,
                  onUpdateOrder: _ctx.updateOrder
                }, null, 8, ["billingContact", "orderId", "billTo", "onUpdateOrder"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("table", _hoisted_32, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        (_ctx.isOceanOrder)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_33, "Ship Line"))
                          : _createCommentVNode("", true),
                        (_ctx.isOceanOrder)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_34, "Vessel Name"))
                          : _createCommentVNode("", true),
                        (_ctx.isOceanOrder)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_35, _toDisplayString(!_ctx.isExportOrder ? 'Vessel ETA' : 'Vessel Cutoff'), 1))
                          : _createCommentVNode("", true),
                        (_ctx.isOceanOrder)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_36, "Vessel Tracking"))
                          : _createCommentVNode("", true),
                        _cache[38] || (_cache[38] = _createElementVNode("th", null, "Reference #", -1)),
                        _cache[39] || (_cache[39] = _createElementVNode("th", null, "Billing Customer Ref #", -1)),
                        _cache[40] || (_cache[40] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        (!_ctx.isEditingVesselInformation && _ctx.isOceanOrder)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(_ctx.order.shipLine), 1))
                          : (_ctx.isOceanOrder)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                                _createVNode(_component_FilterableDropdown, {
                                  taggable: "",
                                  "push-tag": "",
                                  modelValue: _ctx.shipLine,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.shipLine) = $event)),
                                  options: _ctx.steamshipLines,
                                  components: { OpenIndicator: null, Deselect: null }
                                }, null, 8, ["modelValue", "options"])
                              ]))
                            : (
                      _ctx.isExportOrder &&
                      _ctx.isEditingVesselInformation &&
                      _ctx.isOceanOrder
                    )
                              ? (_openBlock(), _createElementBlock("td", _hoisted_39, [
                                  _createVNode(_component_InputField, {
                                    id: "editBookingNumber",
                                    modelValue: _ctx.newBookingNumber,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newBookingNumber) = $event))
                                  }, null, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                        (!_ctx.isEditingVesselInformation && _ctx.isOceanOrder)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_40, _toDisplayString(_ctx.order.vesselName), 1))
                          : (_ctx.isOceanOrder)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                                _createVNode(_component_FilterableDropdown, {
                                  taggable: "",
                                  "push-tag": "",
                                  modelValue: _ctx.vesselName,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.vesselName) = $event)),
                                  options: _ctx.filteredVessels,
                                  components: { OpenIndicator: null, Deselect: null }
                                }, null, 8, ["modelValue", "options"]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "tw-h-10 tw-shrink-0 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
                                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.openAddVesselModal && _ctx.openAddVesselModal(...args)))
                                }, "Add"),
                                _createVNode(_component_EditVessel, {
                                  isOpen: _ctx.showAddVesselModal,
                                  "onUpdate:isOpen": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showAddVesselModal) = $event)),
                                  onClose: _ctx.closeAddVesselModal,
                                  onSaved: _ctx.onAddVesselSaved
                                }, null, 8, ["isOpen", "onClose", "onSaved"])
                              ]))
                            : _createCommentVNode("", true),
                        (!_ctx.isEditingVesselInformation && _ctx.isOceanOrder)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_42, _toDisplayString(_ctx.formatVesselEtaDate(_ctx.order.vesselEtaString)), 1))
                          : (_ctx.isOceanOrder)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_43, [
                                _createVNode(_component_DatePicker, {
                                  class: "uk-form-label",
                                  "input-class": 'uk-input uk-width-medium',
                                  clearable: true,
                                  format: "MM/DD/YYYY",
                                  onChange: _ctx.changedETA,
                                  modelValue: _ctx.vesselEta,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.vesselEta) = $event)),
                                  "show-days-shortcuts": "",
                                  "controls-placement": "popup"
                                }, null, 8, ["onChange", "modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                        (_ctx.isOceanOrder)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                              (_ctx.order.vessel && _ctx.order.vessel.mssi)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-slate-700 tw-shadow-sm hover:tw-bg-white",
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isVesselTrackingOpen = !_ctx.isVesselTrackingOpen))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "ship",
                                      class: "tw-h-3.5 tw-w-3.5"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.isVesselTrackingOpen ? 'Hide Tracking' : 'View Tracking'), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_45, "No vessel data"))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, [
                          (!_ctx.order.referenceNumber)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                (_ctx.isEditingReferenceNumber)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                      _createElementVNode("div", _hoisted_48, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editingReferenceNumber) = $event)),
                                          class: "tw-w-64 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                                          placeholder: "Reference #"
                                        }, null, 512), [
                                          [_vModelText, _ctx.editingReferenceNumber]
                                        ]),
                                        _createVNode(_component_Button, {
                                          onClick: _ctx.saveReferenceNumber,
                                          class: "tw-h-9 tw-w-9 tw-p-0",
                                          icon: "check",
                                          title: "Save reference number",
                                          "aria-label": "Save reference number"
                                        }, null, 8, ["onClick"]),
                                        _createVNode(_component_Button, {
                                          isGray: true,
                                          onClick: _ctx.cancelReferenceNumberEdit,
                                          class: "tw-h-9 tw-w-9 tw-p-0",
                                          icon: "xmark",
                                          title: "Cancel reference number edit",
                                          "aria-label": "Cancel reference number edit"
                                        }, null, 8, ["onClick"])
                                      ])
                                    ]))
                                  : (_openBlock(), _createBlock(_component_Button, {
                                      key: 1,
                                      onClick: _ctx.editReferenceNumber
                                    }, {
                                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                        _createTextVNode("Add Ref Number", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick"]))
                              ]))
                            : (!_ctx.isEditingVesselInformation)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.order.referenceNumber), 1))
                              : (_openBlock(), _createBlock(_component_InputField, {
                                  key: 2,
                                  id: "editReferenceNumber",
                                  modelValue: _ctx.newReferenceNumber,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newReferenceNumber) = $event))
                                }, null, 8, ["modelValue"]))
                        ]),
                        _createElementVNode("td", null, [
                          (!_ctx.isEditingVesselInformation)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.order.billingReferenceNumber), 1))
                            : (_openBlock(), _createBlock(_component_InputField, {
                                key: 1,
                                id: "editReferenceNumber",
                                modelValue: _ctx.newBillingReferenceNumber,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newBillingReferenceNumber) = $event))
                              }, null, 8, ["modelValue"]))
                        ]),
                        _createElementVNode("td", null, [
                          (!_ctx.isEditingVesselInformation)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5 hover:tw-bg-slate-900/5 hover:tw-text-slate-900",
                                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.editVesselInformation && _ctx.editVesselInformation(...args))),
                                "aria-label": "Edit vessel information",
                                title: "Edit vessel information"
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "pen-to-square",
                                  class: "tw-h-4 tw-w-4"
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]),
                (_ctx.isEditingVesselInformation)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createVNode(_component_Button, {
                        isGreen: true,
                        onClick: _ctx.saveVesselInformation,
                        icon: "check",
                        "aria-label": "Save vessel information",
                        title: "Save vessel information"
                      }, {
                        default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                          _createTextVNode("Save", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        isRed: true,
                        isSecondary: true,
                        onClick: _ctx.cancelEditVesselInformation,
                        "aria-label": "Cancel vessel information edit",
                        title: "Cancel vessel information edit"
                      }, {
                        default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                          _createTextVNode("Cancel", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_OrderContainersTable, {
                  order: _ctx.order,
                  onShowContainer: _ctx.showContainer,
                  containersWithTrips: _ctx.containersWithTrips,
                  onRefreshOrders: _ctx.emitRefreshOrders,
                  chassis: _ctx.chassis,
                  drivers: _ctx.drivers,
                  isLoadingContainersQuery: !!_ctx.$apollo?.queries?.orderContainers?.loading,
                  onUpdateContainers: _ctx.updateContainers,
                  onShowContainerDetails: _ctx.showContainerDetails
                }, null, 8, ["order", "onShowContainer", "containersWithTrips", "onRefreshOrders", "chassis", "drivers", "isLoadingContainersQuery", "onUpdateContainers", "onShowContainerDetails"])
              ]),
              (_ctx.company.settingsOrderShowEmergencyInformation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _cache[45] || (_cache[45] = _createElementVNode("h3", { class: "uk-margin-remove-bottom uk-width-1-6" }, " Emergency Information ", -1)),
                      _createElementVNode("a", {
                        class: "uk-icon-link uk-align-left uk-margin-remove",
                        type: "button",
                        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.toggleIsEditingEmergencyInformation && _ctx.toggleIsEditingEmergencyInformation(...args)))
                      }, [...(_cache[44] || (_cache[44] = [
                        _createElementVNode("span", { "uk-icon": "icon:  file-edit; ratio:1.2" }, null, -1)
                      ]))])
                    ]),
                    (!_ctx.isEditingEmergencyInformation)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createElementVNode("p", null, [
                            _cache[46] || (_cache[46] = _createElementVNode("strong", null, "Phone Number:", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.order.emergencyResponsePhoneNumber), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _createVNode(_component_InputField, {
                            class: "uk-width-1-6",
                            id: "EmergencyPhoneNumber",
                            label: "Phone Number",
                            modelValue: _ctx.emergencyInformation.phoneNumber,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.emergencyInformation.phoneNumber) = $event))
                          }, null, 8, ["modelValue"])
                        ])),
                    (_ctx.isEditingEmergencyInformation)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createVNode(_component_Button, {
                            isDefault: true,
                            class: "uk-button-primary tw-h-9 tw-w-9 tw-p-0",
                            onClick: _ctx.saveEmergencyInformation,
                            icon: "check",
                            title: "Save emergency information",
                            "aria-label": "Save emergency information"
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            onClick: _ctx.cancelEditEmergencyInformation,
                            isDefault: true,
                            class: "uk-button-secondary tw-h-9 tw-w-9 tw-p-0",
                            isGray: true,
                            icon: "xmark",
                            title: "Cancel emergency information edit",
                            "aria-label": "Cancel emergency information edit"
                          }, null, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
    ]),
    (_ctx.order && _ctx.order.vessel && _ctx.order.vessel.mssi)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          isOpen: _ctx.isVesselTrackingOpen,
          "onUpdate:isOpen": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.isVesselTrackingOpen) = $event)),
          modalId: `vessel-tracking-${_ctx.order.id}`,
          maxWidth: "4xl"
        }, {
          title: _withCtx(() => [
            _createTextVNode("Vessel Tracking: " + _toDisplayString(_ctx.order.vesselName) + " (" + _toDisplayString(_ctx.order.vessel.mssi) + ")", 1)
          ]),
          subtitle: _withCtx(() => [...(_cache[47] || (_cache[47] = []))]),
          content: _withCtx(() => [
            _createVNode(_component_VesselFinderEmbed, {
              mssi: _ctx.order.vessel.mssi,
              height: "100%",
              isShowTitle: false,
              isFitParentDimensions: ""
            }, null, 8, ["mssi"])
          ]),
          _: 1
        }, 8, ["isOpen", "modalId"]))
      : _createCommentVNode("", true)
  ]))
}